module.exports = __webpack_public_path__ + "assets/a597df94c291711019fbe6298316cbc4.png";